import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { changeLocation } from 'api/Location';
import { getRequest, postRequest, batchRequest } from '../../api/ApiService';
import Auth from '../../routes/Auth';

import { Loader } from 'react-loaders';

import { isSurveyFinished } from '../../api/Surveys';

import Navigation from './components/navigation';
import Pagination from './components/pagination';

import TeamworkSkills from './pages/overview/teamworks-skills';
import SelfAssessment from './pages/overview/self-assessment';
import PeerRatingScoreInitial from './pages/overview/peer-rating-score-initial';
import PeerRatingScoreSecond from './pages/overview/peer-rating-score-second';

import FeedbackStep1 from './pages/feedback/step1';
import FeedbackStep2 from './pages/feedback/step2';
import WorkEthics from './pages/feedback/work-ethics';
import Communication from './pages/feedback/communication';
import ProblemSolvingStep1 from './pages/feedback/problem-solving-step1';
import ProblemSolvingStep2 from './pages/feedback/problem-solving-step2';
import Supportive from './pages/feedback/supportive';
import Contribution from './pages/feedback/contribution';
import TeamInteraction from './pages/feedback/team-interaction';
import KeepOnTrack from './pages/feedback/keep-on-track';
import QualityWork from './pages/feedback/quality-work';
import KnowledgeSkills from './pages/feedback/knowledge-skills';
import ManagingConflict from './pages/feedback/managing-conflict';

import CareerPathwayStep1 from './pages/career-pathway/step1';
import CareerPathwayStep2 from './pages/career-pathway/step2';

import GoodLuck from './pages/good-luck';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;

  .loader {
    display: inline-block;
    margin-top: 20px;
    margin-left: 20px;
  }

  .loader .loader-inner div {
    border-color: #36507e;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-self: stretch;
  background: #f5f6f7;

  .loader {
    display: inline-block;
    margin-top: 20px;
    margin-left: 20px;
  }

  .loader .loader-inner div {
    border-color: #36507e;
  }
`;

const ContentWrapper = styled.div`
  flex: 1;
  width: 80%;
  max-width: 794px;
  background: #f5f6f7;
`;

class PeerFeedback extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      currentCategory: 0,
      currentStep: 0,
      navigation: [],
      loaded: false,
      visitsHistory: [],
      surveys: [],
      courses: []
    };
  }

  componentDidMount() {
    this.loadNavigation(() => {
      this.updateCurrentState();
    });
  }

  get activeRound() {
    const { currentRound, roundInUrl } = this.props;

    return roundInUrl || currentRound;
  }

  loadNavigation(callback) {
    batchRequest([
      `${process.env.REACT_APP_API_URL}v2/forms/surveys`,
      `${process.env.REACT_APP_API_URL}courses/`
    ]).then(res => {

      const surveys = res[0].body.results;

      const initialSurvey = surveys.find(i => i.stage === 'initial');
      const secondSurvey = surveys.find(i => i.stage === 'second');

      const finishedSurveys =
        surveys && surveys.length > 0
          ? surveys.filter(i => isSurveyFinished(i))
          : [];

      const lastFinishedSurvey =
        finishedSurveys.length > 0
          ? finishedSurveys[finishedSurveys.length - 1]
          : null;

      const courseId = Number(Auth.getCourseId());
      let courses = [];
      const course = res[1].body.find(i => Number(i.id) === courseId);

      if (course && course.subcourses) {
        courses = course.subcourses.filter(i => [
          'leadership',
        ].includes(i.category.toLowerCase()));
      }

      const showLeadershipPathway = courses.length > 0;

      const showWorkEthics = lastFinishedSurvey ? lastFinishedSurvey.questions.find(i => i.text === 'Work Ethics') : false;
      const showCommunication = lastFinishedSurvey ? lastFinishedSurvey.questions.find(i => i.text === 'Communication') : false;
      const showAnalytical = lastFinishedSurvey ? lastFinishedSurvey.questions.find(i => i.text === 'Analytical') : false;
      const showConflictManagement = lastFinishedSurvey ? lastFinishedSurvey.questions.find(i => i.text === 'Conflict Management') : false;
      const showSupportive = lastFinishedSurvey ? lastFinishedSurvey.questions.find(i => i.text === 'Supportive') : false;
      const showContribution = lastFinishedSurvey ? lastFinishedSurvey.questions.find(i => i.text === 'Contributing to Teamwork') : false;
      const showTeamInteraction = lastFinishedSurvey ? lastFinishedSurvey.questions.find(i => i.text === 'Interacting with Teammates') : false;
      const showKeepOnTrack = lastFinishedSurvey ? lastFinishedSurvey.questions.find(i => i.text === 'Keeping the Team on Track') : false;
      const showQualityWork = lastFinishedSurvey ? lastFinishedSurvey.questions.find(i => i.text === 'Expecting Quality') : false;
      const showKnowledgeSkills = lastFinishedSurvey ? lastFinishedSurvey.questions.find(i => i.text === 'Having Relevant Knowledge, Skills, and Abilities') : false;
      const showManagingConflict = lastFinishedSurvey ? lastFinishedSurvey.questions.find(i => i.text === 'Managing Conflict') : false;

      const selfAssessmentQuestions = lastFinishedSurvey ? lastFinishedSurvey.questions.filter(i => i.category === 'self_assessment') : [];
      const showSelfAssessment = selfAssessmentQuestions.filter(i => [
        'SELF | Analytical',
        'SELF | Conflict Management',
        'SELF | Supportive',
        'SELF | Communication',
        'SELF | Work Ethics',
        'SELF | Contributing to the Teams Work',
        'SELF | Interacting with Teammates',
        'SELF | Keeping the Team on Track',
        'SELF | Expecting Quality',
        'SELF | Having Relevant Knowledge, Skills, and Abilities',
        'SELF | Conflict Management',
      ].includes(i.text)).length > 0;

      const navigation = [
        {
          title: 'Overview',
          pattern: '/peer-feedback/',
          steps: [
            {
              url: '/peer-feedback/teamwork-skills',
              component: TeamworkSkills,
            }
          ],
        },
        ...(showSelfAssessment ? [
          {
            title: 'Self-Assessment',
            pattern: '/peer-feedback/self-assessment',
            parent: 'Overview',
            steps: [
              {
                url: '/peer-feedback/self-assessment',
                component: SelfAssessment,
              }
            ],
          },
        ] : []),
        ...(initialSurvey || secondSurvey ? [
          {
            title: 'Peer Rating',
            pattern: '/peer-feedback/peer-rating-score',
            parent: 'Overview',
            steps: [
              ...(initialSurvey && !secondSurvey ? [
                {
                  url: '/peer-feedback/peer-rating-score',
                  component: PeerRatingScoreInitial,
                }
              ] : []),
              ...(secondSurvey ? [
                {
                  url: '/peer-feedback/peer-rating-score',
                  component: PeerRatingScoreSecond,
                }
              ] : []),
            ],
          }
        ] : []),
        {
          title: 'Feedback',
          pattern: '/peer-feedback/feedback',
          steps: [
            {
              url: '/peer-feedback/feedback/strengths-and-areas-of-development',
              component: FeedbackStep1,
            },
            {
              url: '/peer-feedback/feedback/teamwork-skills-that-you-are-demonstrating',
              component: FeedbackStep2,
            },
          ],
        },
        ...(showWorkEthics ? [
          {
            title: 'Work Ethics',
            pattern: '/peer-feedback/work-ethics',
            parent: 'Feedback',
            steps: [
              {
                url: '/peer-feedback/work-ethics',
                component: WorkEthics,
              },
            ],
          }
        ] : []),
        ...(showCommunication ? [
          {
            title: 'Communication',
            pattern: '/peer-feedback/communication',
            parent: 'Feedback',
            steps: [
              {
                url: '/peer-feedback/communication',
                component: Communication,
              },
            ],
          }
        ] : []),
        ...(showAnalytical || showConflictManagement ? [
          {
            title: 'Problem Solving',
            pattern: '/peer-feedback/problem-solving',
            parent: 'Feedback',
            steps: [
              ...(showAnalytical ? [
                {
                  url: '/peer-feedback/problem-solving/analytical',
                  component: ProblemSolvingStep1,
                }
              ] : []),
              ...(showConflictManagement ? [
                {
                  url: '/peer-feedback/problem-solving/conflict-management',
                  component: ProblemSolvingStep2,
                }
              ] : []),
            ],
          }
        ] : []),
        ...(showSupportive ? [
          {
            title: 'Supportive',
            pattern: '/peer-feedback/supportive',
            parent: 'Feedback',
            steps: [
              {
                url: '/peer-feedback/supportive',
                component: Supportive,
              },
            ],
          }
        ] : []),
        ...(showContribution ? [
          {
            title: 'Contribution',
            pattern: '/peer-feedback/contribution',
            parent: 'Feedback',
            steps: [
              {
                url: '/peer-feedback/contribution',
                component: Contribution,
              },
            ],
          }
        ] : []),
        ...(showTeamInteraction ? [
          {
            title: 'Team Interaction',
            pattern: '/peer-feedback/team-interaction',
            parent: 'Feedback',
            steps: [
              {
                url: '/peer-feedback/team-interaction',
                component: TeamInteraction,
              },
            ],
          }
        ] : []),
        ...(showKeepOnTrack ? [
          {
            title: 'Keeping On Track',
            pattern: '/peer-feedback/keep-on-track',
            parent: 'Feedback',
            steps: [
              {
                url: '/peer-feedback/keep-on-track',
                component: KeepOnTrack,
              },
            ],
          }
        ] : []),
        ...(showQualityWork ? [
          {
            title: 'Quality Work',
            pattern: '/peer-feedback/quality-work',
            parent: 'Feedback',
            steps: [
              {
                url: '/peer-feedback/quality-work',
                component: QualityWork,
              },
            ],
          }
        ] : []),
        ...(showKnowledgeSkills ? [
          {
            title: 'Knowledge & Skills',
            pattern: '/peer-feedback/knowledge-and-skills',
            parent: 'Feedback',
            steps: [
              {
                url: '/peer-feedback/knowledge-and-skills',
                component: KnowledgeSkills,
              },
            ],
          }
        ] : []),
        ...(showManagingConflict ? [
          {
            title: 'Managing Conflict',
            pattern: '/peer-feedback/managing-conflict',
            parent: 'Feedback',
            steps: [
              {
                url: '/peer-feedback/managing-conflict',
                component: ManagingConflict,
              },
            ],
          }
        ] : []),
        ...(showLeadershipPathway ? [
          {
            title: 'Leadership Pathway',
            pattern: '/peer-feedback/leadership-pathway',
            steps: [
              {
                url: '/peer-feedback/leadership-pathway/supply-chain-management',
                component: CareerPathwayStep1,
              },
              {
                url: '/peer-feedback/leadership-pathway/career-pathway-courses',
                component: CareerPathwayStep2,
              },
            ],
          },
        ] : []),
        {
          title: 'Good Luck!',
          pattern: '/peer-feedback/good-luck',
          steps: [
            {
              url: '/peer-feedback/good-luck',
              component: GoodLuck,
            },
          ],
        },
      ];

      if (JSON.stringify(navigation) !== JSON.stringify(this.state.navigation)) {
        this.setState({
          navigation,
          loaded: true,
          surveys,
          courses
        }, () => {
          if (callback) {
            callback();
          }
        });
      } else {
        if (callback) {
          callback();
        }
      }
    })
      .catch(err => { });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.updateCurrentState();
    }
  }

  updateCurrentState = () => {
    const { navigation } = this.state;

    this.setState({
      loaded: false,
    });
    getRequest(`${process.env.REACT_APP_API_URL}v2/engagement/tracks/`)
      .then(res => {
        const activeRound = this.activeRound;
        const user_id = Number(Auth.getUserId());
        const round_number = Number(activeRound);
        const game_id = Number(Auth.getGameId());
        const course_id = Number(Auth.getCourseId());

        const visitsHistory = res.body.results
          .filter(i => (
            Number(i.course) === course_id &&
            Number(i.game) === game_id &&
            Number(i.round_number) === round_number &&
            Number(i.user) === user_id &&
            i.page.indexOf(`${window.location.protocol}//${window.location.host}`) === 0
          ))
          .map(i => i.page.replace(`${window.location.protocol}//${window.location.host}`, ''));

        let currentCategory = 0;
        let currentStep = 0;
        let found = false;

        for (let i = 0; i < navigation.length; i++) {
          const stepIndex = navigation[i].steps.findIndex(j => j.url === this.props.location.pathname);
          if (stepIndex > -1) {
            currentCategory = i;
            currentStep = stepIndex;
            found = true;
            break;
          }
        }

        if (!found) {
          let needBreak = false;
          for (let i = 0; i < navigation.length; i++) {
            if (needBreak === true) {
              break;
            }

            for (let j = 0; j < navigation[i].steps.length; j++) {
              if (visitsHistory.includes(navigation[i].steps[j].url)) {
                currentCategory = i;
                currentStep = j;
              } else {
                needBreak = true;
                break;
              }
            }
          }
        }

        if (
          currentCategory !== this.state.currentCategory
          || currentStep !== this.state.currentStep
        ) {
          this.setState({
            currentCategory,
            currentStep,
            visitsHistory,
            loaded: true,
          }, () => {
            this.checkLocation();
          });
        } else {
          this.setState({
            visitsHistory,
            loaded: true,
          });

          if (this.props.location.pathname === '/performance-feedback') {
            this.checkLocation();
          }
        }
      })
      .catch(err => { });
  }

  checkLocation = () => {
    const { currentCategory, currentStep, navigation } = this.state;
    const activeRound = this.activeRound;

    if (this.props.location.pathname !== navigation[currentCategory].steps[currentStep].url) {
      this.setState({
        loaded: false,
      });

      getRequest(`${process.env.REACT_APP_API_URL}v2/engagement/tracks/`)
        .then(res => {
          const user_id = Number(Auth.getUserId());
          const round_number = Number(activeRound);
          const game_id = Number(Auth.getGameId());
          const course_id = Number(Auth.getCourseId());
          const current_page = `${navigation[currentCategory].steps[currentStep].url}`;

          const visitsHistory = res.body.results
            .filter(i => (
              Number(i.course) === course_id &&
              Number(i.game) === game_id &&
              Number(i.round_number) === round_number &&
              Number(i.user) === user_id &&
              i.page.indexOf(`${window.location.protocol}//${window.location.host}`) === 0
            ))
            .map(i => i.page.replace(`${window.location.protocol}//${window.location.host}`, ''));
          if (!visitsHistory.includes(current_page)) {
            postRequest(`${process.env.REACT_APP_API_URL}v2/engagement/tracks/`)
              .send({
                page: `${window.location.protocol}//${window.location.host}${current_page}`,
                user: user_id,
                course: course_id,
                game: game_id,
                round_number: round_number,
              })
              .then((data) => {
                this.setState({
                  visitsHistory: [
                    ...visitsHistory,
                    current_page,
                  ],
                  loaded: true,
                });
              });
          } else {
            this.setState({
              visitsHistory,
              loaded: true,
            });
          }
        })
        .catch(err => { });

      changeLocation(`${navigation[currentCategory].steps[currentStep].url}?round=${activeRound}`);
    }
  }

  goNext = e => {
    e.preventDefault();

    const { currentCategory, currentStep, navigation } = this.state;

    let nextCategory = currentCategory;
    let nextStep = currentStep + 1;
    if (nextStep >= navigation[currentCategory].steps.length) {
      nextCategory = currentCategory + 1;
      nextStep = 0;

      if (nextCategory >= navigation.length) {
        return false;
      } else if (nextStep >= navigation[nextCategory].steps.length) {
        nextCategory = currentCategory + 2;
        nextStep = 0;

        if (nextCategory >= navigation.length) {
          return false;
        }
      }
    }

    this.setState({
      currentCategory: nextCategory,
      currentStep: nextStep,
    }, () => {
      this.checkLocation();
    });

    return false;
  }

  goPrev = e => {
    e.preventDefault();

    const { currentCategory, currentStep, navigation } = this.state;

    let prevCategory = currentCategory;
    let prevStep = currentStep - 1;
    if (prevStep < 0) {
      prevCategory = currentCategory - 1;
      if (prevCategory < 0) {
        return false;
      }

      prevStep = navigation[prevCategory].steps.length - 1;
      if (prevStep < 0) {
        prevCategory = currentCategory - 2;
        if (prevCategory < 0) {
          return false;
        }

        prevStep = navigation[prevCategory].steps.length - 1;
      }
    }

    this.setState({
      currentCategory: prevCategory,
      currentStep: prevStep,
    }, () => {
      this.checkLocation();
    });

    return false;
  }

  get isFirstStep() {
    const { currentCategory, currentStep } = this.state;

    return currentCategory === 0 && currentStep === 0;
  }

  get isLastStep() {
    const { currentCategory, currentStep, navigation } = this.state;

    const lastCategory = navigation.length - 1;
    const lastStep = navigation[lastCategory].steps.length - 1;

    return currentCategory === lastCategory && currentStep === lastStep;
  }

  get countOfSteps() {
    const { currentCategory, navigation } = this.state;

    return navigation[currentCategory].steps.length;
  }

  render() {
    const {
      currentCategory,
      currentStep,
      navigation,
      loaded,
      visitsHistory,
      surveys,
      courses
    } = this.state;
    const activeRound = this.activeRound;

    if (navigation.length === 0 || !loaded) {
      return (
        <Wrapper>
          <Loader type="ball-scale-ripple" active />
        </Wrapper>
      );
    }

    const category = navigation[currentCategory];
    let Component = null;
    if (category) {
      Component = category.steps[currentStep].component;
    }

    return (
      <Wrapper>
        <Navigation
          data={navigation}
          category={currentCategory}
          visitsHistory={visitsHistory}
          activeRound={activeRound}
        />
        <Content>
          <ContentWrapper>
            {Component && (
              <Component
                surveys={surveys}
                courses={courses}
              />
            )}
          </ContentWrapper>
          <Pagination
            goNext={this.goNext}
            goPrev={this.goPrev}
            isFirstStep={this.isFirstStep}
            isLastStep={this.isLastStep}
            currentStep={currentStep + 1}
            countOfSteps={this.countOfSteps}
          />
        </Content>
      </Wrapper>
    );
  }

}

export default PeerFeedback;



// WEBPACK FOOTER //
// ./src/components/peer-feedback/index.js